import { lazyLaunchStoreUrl } from 'owa-addins-marketplace';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
export function mailInClientStoreRouteHandler(parameters) {
    if (isMailFeatureEnabled('addins-launchAddinsFromUrl')) {
        if (parameters.assetId) {
            if (parameters.campaignId && parameters.providerId) {
                lazyLaunchStoreUrl.import().then(function (launchDetailsPage) {
                    launchDetailsPage(false /*openHomePage = false*/, parameters.assetId, parameters.campaignId, parameters.providerId);
                });
            }
            else {
                lazyLaunchStoreUrl.import().then(function (launchDetailsPage) {
                    launchDetailsPage(false /*openHomePage = false*/, parameters.assetId);
                });
            }
        }
        else {
            lazyLaunchStoreUrl.import().then(function (launchHomePage) {
                launchHomePage(true /*openHomePage = true*/);
            });
        }
    }
}
//# sourceMappingURL=mailInClientStoreRouteHandler.js.map